module.exports = __webpack_public_path__ + "static/img/1-2.083a85a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/1-2.png
// module id = Me7w
// module chunks = 1